import React, { useState } from "react";
import InputMask from "react-input-mask";
import createTicket from "../../services/jiraService";
import CustomSelect from "../../components/CustomSelect/Select";
import Info from "../../assets/svg/info.svg";
import "./FormIntegration.css";

function FormIntegration() {
  const [razaoSocial, setRazaoSocial] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [nomeAdministrador, setNomeAdministrador] = useState("");
  const [adminEmail, setAdminEmail] = useState("");

  const [callEmail, setCallEmail] = useState("");
  const [adminCpf, setAdminCpf] = useState("");
  const [observacao, setObservacao] = useState("");
  const [produtos, setProdutos] = useState([]);
  const [perfil, setPerfil] = useState([]);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseError, setResponseError] = useState(false);
  const [sending, setSending] = useState(false);
  const [submited, setSubmited] = useState(false);
  const [isGestaoParticipantes, setIsGestaoParticipantes] = useState(false);

  const resetForm = () => {
    setRazaoSocial("");
    setCnpj("");
    setNomeAdministrador("");
    setAdminEmail("");
    setCallEmail("");
    setAdminCpf("");
    setObservacao("");
    setProdutos([]);
    setPerfil([]);
    setResponseMessage("");
    setIsGestaoParticipantes(false);
    setResponseMessage("");
  };

  const closeMsg = () => {
    setResponseError(false);
    setSubmited(false);
    resetForm();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!sending) {
      const ticketData = {
        razao_social: razaoSocial,
        cnpj: cnpj,
        nome_admin: nomeAdministrador,
        email_admin: adminEmail,
        email_call: callEmail,
        cpf_admin: adminCpf,
        observacao: observacao,
        produtos: produtos.map((produto) => produto.value),
        perfil: perfil.value,
        tipo_problema: "Novo Cliente",
        tipo_ticket: "integracao",
        tipo_integration: isGestaoParticipantes
          ? "gestaoParticipantes"
          : "participanteDireto",
      };

      setSending(true);

      try {
        const response = await createTicket(ticketData);
        if (response.status === 201) {
          setResponseMessage(
            `Ticket criado com sucesso. Ticket Key: ${response.data.ticket_key}`
          );
        } else {
          setResponseMessage(
            `Falha ao criar ticket. Status Code: ${response.status}`
          );
        }
      } catch (error) {
        setResponseMessage(
          error.response ? error.response.data : error.response.data.message
        );
        setResponseError(true);
      } finally {
        setSending(false);
        setSubmited(true);
      }
    }
  };

  const produtoOptions = [
    { value: "RegistrAtivos", label: "RegistrAtivos" },
    { value: "MonitorAtivos", label: "MonitorAtivos" },
    { value: "BuscAtivos", label: "BuscAtivos" },
    { value: "CapturAtivos", label: "CapturAtivos" },
    { value: "BookVariaveis", label: "Book de Variáveis" },
    { value: "BookVariaveis", label: "Escrituradora" },
  ];

  const perfilOptions = [
    { value: "admin", label: "Administrador" },
    { value: "bancarizador", label: "Bancarizador" },
    { value: "gestor", label: "Gestor" },
    { value: "consultoria", label: "Consultoria" },
    { value: "fidc", label: "FIDC" },
    { value: "security", label: "Securitizadora e Factoring" },
    { value: "agenteEscrituracao", label: "Agente de escrituração" },
    { value: "prestadorRepresentante", label: "Prestador de serviço/ Representante" },
  ];

  const parseResponseMsg = (msg) => {
    if (typeof msg === "string") {
      return msg;
    }
    return msg.message;
  };

  return (
    <div
      className={`form-integration ${responseError ? "response-error" : ""}`}
    >
      {!submited && (
        <header className="form-integration-header">
          <h1>Integração via API</h1>
        </header>
      )}

      {!submited && (
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="razaoSocial">Razão Social / Nome Fantasia</label>
            <input
              type="text"
              name="razaoSocial"
              className="razao-social-input"
              placeholder="Insira a Razão Social / Nome Fantasia"
              value={razaoSocial}
              onChange={(e) => setRazaoSocial(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="cnpj">CNPJ</label>
            <InputMask
              type="text"
              name="cnpj"
              className="cnpj-input"
              placeholder="Insira o CNPJ"
              mask="99.999.999/9999-99"
              value={cnpj}
              onChange={(e) => setCnpj(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="nomeAdministrador">
              Nome do Usuário Administrador
            </label>
            <input
              type="text"
              name="nomeAdministrador"
              className="nome-administrador-input"
              placeholder="Insira o nome"
              value={nomeAdministrador}
              onChange={(e) => setNomeAdministrador(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="adminEmail">Email do Usuário Administrador</label>
            <input
              type="email"
              name="adminEmail"
              className="admin-email-input"
              placeholder="Insira o email"
              value={adminEmail}
              onChange={(e) => setAdminEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="callEmail">Email para contato</label>
            <input
              type="email"
              name="callEmail"
              className="call-email-input"
              placeholder="Insira o email"
              value={callEmail}
              onChange={(e) => setCallEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="adminCpf">CPF do Usuário Administrador</label>
            <InputMask
              type="text"
              name="adminCpf"
              className="admin-cpf-input"
              placeholder="Insira o CPF"
              mask="999.999.999-99"
              value={adminCpf}
              onChange={(e) => setAdminCpf(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="produto">
              Produtos para integração
              <span className="tooltip-icon">
                <img src={Info} alt="info" />
              </span>
              <div className="tooltip-text">
                <ul>
                  <li>
                    <b>RegistrAtivos</b> - Registro de Ativos Financeiros
                    (Duplicatas, CCBs, Notas Promissórias)
                  </li>
                  <li>
                    <b>MonitorAtivos</b> - Monitoramento de status da nota
                    fiscal eletrônica (NF-e)
                  </li>
                  <li>
                    <b>BuscAtivos</b> - Verificação da Unicidade dos Ativos
                    Financeiros de Duplicatas e CCBs
                  </li>
                  <li>
                    <b>CapturAtivos</b> - Captura de XML da NF-e junto a Serpro
                  </li>
                </ul>
              </div>
            </label>
            <CustomSelect
              options={produtoOptions}
              onChange={setProdutos}
              placeholder="Selecione o(s) produto(s)"
              isMulti
            />
          </div>
          <div>
            <label htmlFor="perfil">Perfil de Integração</label>
            <CustomSelect
              options={perfilOptions}
              onChange={(option) => setPerfil(option)}
              placeholder="Selecione o perfil"
            />
          </div>
          <div>
            <div className="radio-group">
              <input
                className="radio-btn"
                type="radio"
                name="tipoIntegracao"
                value="participanteDireto"
                checked={!isGestaoParticipantes}
                onChange={() => setIsGestaoParticipantes(false)}
                id="radio1"
              />
              <label htmlFor="radio1" className="radio-label">
                <span className="radio-custom"></span>
                <span className="text">
                  Integração direto como participante
                </span>
              </label>
            </div>
            <div className="radio-group">
              <input
                className="radio-btn"
                type="radio"
                name="tipoIntegracao"
                value="gestaoParticipantes"
                checked={isGestaoParticipantes}
                onChange={() => setIsGestaoParticipantes(true)}
                id="radio2"
              />
              <label htmlFor="radio2" className="radio-label">
                <span className="radio-custom"></span>
                <span className="text">Gestão de vários participantes</span>
              </label>
            </div>
          </div>

          <div>
            <label htmlFor="observacao">Observação:</label>
            <textarea
              name="observacao"
              className="observacao-textarea"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
            ></textarea>
          </div>
          <div className={`submit-btn ${sending ? "loading" : ""}`}>
            <button className="btn" type="submit">
              Solicitar
            </button>
          </div>
        </form>
      )}
      {submited && (
        <div className="wrapper-response">
          <span onClick={closeMsg}></span>
          <p>{parseResponseMsg(responseMessage)}</p>
        </div>
      )}
    </div>
  );
}

export default FormIntegration;
